<!--<div  [ngClass]="{'expandedBorder':expanded,'mat-stroked-button':(depth===0&&expanded),'expandedParentBtn':(depth===0&&expanded)}">-->
    <div *ngIf ='showmenu' class="left-nav-fixed" class="left-nav-items" [ngClass]="{'expandedBorder':expanded}">
        <a mat-list-item (click)="onItemSelected(item)" [ngClass]="{'active active-menu': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}">
           <!--<mat-icon class="routeIcon">{{item.iconName}}</mat-icon> -->
           <!--<mat-icon class="routeIcon">home</mat-icon> -->
           <img src="assets/svg/leftNav/{{item.iconName}}" *ngIf="item.iconName" width="24" height="24">&nbsp;&nbsp;
            <ng-container> <span [ngClass]="{expandedParentTextBold:(depth===0&&expanded)}" class="menu-items" translate>{{item.displayName}}</span></ng-container>
            <span fxFlex *ngIf="item.children && item.children.length">
                <span fxFlex></span>
                <div *ngIf ='!expanded'>
                    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" style="position: relative; right: 20px;">
                        <g stroke="#333" fill="none" fill-rule="evenodd"><path d="M0 7.5h15M7.5 0v15"></path></g>
                    </svg>
                </div>
                <div *ngIf ='expanded'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 2" height="18" width="18" style="position: relative; right: 20px;">
                        <path d="M0 1h16" stroke="#333" fill="none" fill-rule="evenodd"></path>
                    </svg>
                </div>
            </span>
        </a>
        </div>
        <div *ngIf="expanded" >
            <app-menu-list-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1">
            </app-menu-list-item>
        </div>
        <!--<ng-container *ngIf="!expanded&&item.children && item.children.length>0"><hr class="thin"></ng-container>  -->
